import { render } from "./RoomForm.vue?vue&type=template&id=63d6f185"
import script from "./RoomForm.vue?vue&type=script&lang=js"
export * from "./RoomForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__